// APP - Konfigurasi Aplikasi
export const APP = {
    NAME: 'MEE',
    CURRENCY: 'IDR',
    LOCALE: 'id-ID',
} as const;

// ROLES - Peran pengguna dalam sistem
export const ROLES = {
    ADMIN: 'admin',
    STUDENT: 'student',
    INSTRUCTOR: 'instructor',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

// PAGINATION - Default values untuk pagination
export const PAGINATION_DEFAULTS = {
    PAGE: 1,
    PER_PAGE: 10,
    MAX_PER_PAGE: 100,
} as const;

// STORAGE KEYS - Keys untuk localStorage dan cookies
export const STORAGE_KEYS = {
    ACCESS_TOKEN: 'accessToken',
    USER: 'user',
    THEME: 'theme',
} as const;
